// @ts-nocheck

import type {Agent} from 'src/api-parsers/index';

import Store from './base';


type State = {
  fetching: Promise<undefined> | null | undefined;
  creating: boolean;
  signingIn: boolean;
  signinError: Record<any, any> | null | undefined;
  signupError: Record<any, any> | null | undefined;
  authPath: string | null | undefined;
  postAuthPath: string | null | undefined;
  agent: Agent | null | undefined;
  flags: {
    [key: string]: boolean;
  };
};

export default class MeStore extends Store {
  state: State;

  constructor() {
    super('me');

    this.state = {
      fetching: null,
      creating: false,
      signingIn: false,
      signinError: null,
      signupError: null,
      authPath: null,
      postAuthPath: null,
      agent: null,
      flags: {},
    };
  }

  startFetching(promise: Promise<undefined>) {
    this.setState({
      fetching: promise,
    });
  }

  receiveFetched(agent: Agent) {
    this.setState({
      fetching: null,
      agent,
    });
  }

  startCreating() {
    this.setState({
      creating: true,
    });
  }

  receiveCreated(agent: Agent) {
    this.receiveFetched(agent);
  }

  isAuthed(): boolean {
    return !!this.state.agent;
  }

  clearAuth() {
    this.setState({
      agent: null,
    });
  }

  is(agent: string | Record<any, any>): boolean {
    const id = agent.id || agent;
    return this.state.agent.id === id;
  }

  getSearchApiKey(): string | null | undefined {
    return this.isAuthed() ? this.state.agent.searchApiKey : null;
  }

  getSearchPrefix(): string | null | undefined {
    return this.isAuthed() ? this.state.agent.searchPrefix : null;
  }
}
